import { render, staticRenderFns } from "./UploadImageField.vue?vue&type=template&id=39d39a86&scoped=true"
import script from "./UploadImageField.vue?vue&type=script&lang=ts"
export * from "./UploadImageField.vue?vue&type=script&lang=ts"
import style0 from "./UploadImageField.vue?vue&type=style&index=0&id=39d39a86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d39a86",
  null
  
)

export default component.exports